var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer get-height"},[_c('v-btn',{attrs:{"type":"button","color":"danger--gradient","depressed":"","round":""},on:{"click":_vm.cancelRide}},[_vm._v("\n    "+_vm._s(_vm.$t((_vm.namespace + ".cancelRide")))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }